module.exports = __webpack_public_path__ + "static/media/Bundala.8131834b.png";